import { useEffect, useMemo, useState } from "react";

import {
  activeChildDetail,
  appConstants,
  ChildTimeLineAtom,
} from "../../AtomStore/store";
import { useAtom } from "jotai";
import { useRequestProcessor } from "../../requestProcessor";
import { fetchChildTimeline } from "../../QueryFunctions/queryfunction";

import ChildTimelineItem from "./ChildTimelineItem";
import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";
import moment from "moment";
import { SERVER_DATE_FORMAT } from "../Support/TakeABreak/TakeABreak";

import InfiniteScroll from "react-infinite-scroll-component";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";

const ChildTimeline = () => {
  const [childTimeline, setChildTimeline] = useState({ startIndex: 0 });
  const [activeChild] = useAtom(activeChildDetail);
  const ITEM_PER_PAGE = 50;
  const [dataAvailable, setDataAvailable] = useState(true);
  const { useQueryWrapper } = useRequestProcessor();
  const [length, setLength] = useState(0);
  const [ChildTimeline, setTimeline] = useAtom(ChildTimeLineAtom);
  const [constants] = useAtom(appConstants);
  const [selectedDate, setSelectedDate] = useState(
    moment().format(SERVER_DATE_FORMAT)
  );
  const [error, setError] = useState(null);

  useMemo(() => {
    console.log(
      `[Child Timeline] Fetching Child Timeline for user: ${activeChild?.id}`
    );
  }, [activeChild]);

  const { isLoading, isFetching, refetch } = useQueryWrapper(
    [
      "ChildTimeline",
      "timeline" + activeChild?.id,
      childTimeline,
      selectedDate,
    ],
    () =>
      fetchChildTimeline(
        childTimeline.startIndex,
        setDataAvailable,
        ChildTimeline,
        ITEM_PER_PAGE,
        constants?.INCLUDE_TYPES,
        setLength,
        setTimeline,
        selectedDate
      ),
    {
      keepPreviousData: true,
    },
    {
      onSuccess: (data) => {
        if (data?.status) {
          setError(data?.error);
        } else {
          setTimeline(data);
          setError(null);
        }
      },
      onError: (err) => {
        setError("Failed to fetch the timeline. Please try again later.");
      },
    }
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const next = () => {
    const startIndex = childTimeline.startIndex + ITEM_PER_PAGE;

    setChildTimeline({ startIndex: startIndex });
  };

  const handleRefresh = () => {
    setDataAvailable(true);
    setLength(0);
    refetch();
  };

  console.log("Timeline", ChildTimeline);
  const handleSelectedDate = (val) => {
    // console.log('setSelectedDate: ', val);
    setSelectedDate(val);
  };
  return (
    <>
      <div className="bg-[#eaf3fa] h-full">
        <div className="bg-header h-[40vh] xs:h-[30vh] p-2"></div>
        <div className="bg-white mx-3 px-3 py-4 rounded-2xl relative top-[-200px] lg:top-[-140px] [@media(max-width:768px)and(max-height:550px)]:mt-12 [@media(max-height:550px)]:mt-20">
          {/* <div className=" bg-header h-1 mt-2 mb-4 mx-6 rounded-full"></div> */}

          {isFetching ? <SpinnerLoading /> : <></>}
          {error ? (
            <div className="flex flex-col justify-center items-center ">
              <img
                src="https://img.icons8.com/?size=50&id=45967&format=png&color=000000"
                alt="oops"
              ></img>

              <p className="text-lg font-base text-gray-500 text-center">
                {error}
              </p>
            </div>
          ) : (
            <>
              {/* <div className="w-full bg-[#e5e7eb] rounded-full h-2 dark:bg-gray-700 mt-3">
            <div
              className="bg-header h-2 rounded-full"
              style={{ width: '45%' }}
            ></div>
          </div> */}

              {/* {(isLoading || isFetching) && (
              <div className=" m-3">
                {[1, 2, 3].map((ele) => (
                  <div
                    className="animate-pulse flex items-center space-x-4 mt-4 border-b pb-3"
                    key={ele}
                  >
                    <div className="rounded-full bg-slate-200 h-10 w-10"></div>
                    <div className="flex-1 space-y-6 py-1">
                      <div className="space-y-3">
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-2 bg-slate-200 rounded col-span-2"></div>
                        </div>
                        <div className="h-2 bg-slate-200 rounded"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )} */}

              {/* {Array.isArray(ChildTimeline) &&
            ChildTimeline.length > 0 &&
            !(isLoading || isFetching) ? (
              <ul className="list-none mt-4 px-2">
                {ChildTimeline?.map((items, index) => (
                  <ChildTimelineItem
                    history={""}
                    items={items}
                    key={index}
                    index={index}
                  />
                ))}
              </ul>
            ) : null} */}

              {Array.isArray(ChildTimeline) && ChildTimeline.length > 0 && (
                <InfiniteScroll
                  dataLength={length}
                  next={next}
                  hasMore={dataAvailable}
                  scrollableTarget="scrollable_container"
                >
                  <ul className="list-none">
                    {ChildTimeline?.map((items, index) => (
                      <>
                        {" "}
                        <div className="text-center bg-header/20   sm:mx-20 md:mx-20 lg:mx-50 xl:mx-80 rounded-full py-1 mb-2">
                          <h3 className="text-lg font-bold text-header">
                            {moment(items.dateGroup, "DD-MM-YY").format(
                              "MMMM D, YYYY"
                            )}
                          </h3>
                          {/* <h3 className="text-md font-extrabold"> 03/03</h3> */}
                        </div>
                        <ChildTimelineItem
                          history={""}
                          items={items}
                          key={index}
                          index={index}
                        />
                      </>
                    ))}
                  </ul>
                </InfiniteScroll>
              )}
              {(!Array.isArray(ChildTimeline) ||
                ChildTimeline.length === 0 ||
                ChildTimeline === undefined) && (
                <div className="text-center mt-4 h-[30vh]">
                  <ListEmptyComponent
                    heading={
                      isLoading || isFetching ? "Loading..." : "No Data Found"
                    }
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ChildTimeline;
